const localePt = {
  UDE_ACADEMIES_ERROR: 'Ocorreu um erro ao obter seus academias',
};
export default localePt;
